import React from "react";
import './switch.scss';
var ToggleSwitch = function (props) {
    var id = props.id, name = props.name, checked = props.checked, onChange = props.onChange, optionLabels = props.optionLabels, small = props.small, disabled = props.disabled;
    var handleKeyPress = function (e) {
        e.preventDefault();
        onChange(!checked);
    };
    return (React.createElement("div", { className: "toggle-switch" + (small ? " small-switch" : "") },
        React.createElement("input", { type: "checkbox", name: name, className: "toggle-switch-checkbox", id: id, checked: checked, onChange: function (e) { }, disabled: disabled }),
        id ? (React.createElement("label", { className: "toggle-switch-label", tabIndex: disabled ? -1 : 1, onClick: function (e) { return handleKeyPress(e); }, 
            // onKeyDown={(e) => handleKeyPress(e, data)}
            htmlFor: id },
            React.createElement("span", { className: disabled
                    ? "toggle-switch-inner toggle-switch-disabled"
                    : "toggle-switch-inner", "data-yes": optionLabels[0], "data-no": optionLabels[1], tabIndex: -1 }),
            React.createElement("span", { className: disabled
                    ? "toggle-switch-switch toggle-switch-disabled"
                    : "toggle-switch-switch", tabIndex: -1 }))) : null));
};
ToggleSwitch.defaultProps = {
    optionLabels: ["Yes", "No"],
};
export default ToggleSwitch;
